import React, { useEffect } from "react";
import { Show, SimpleForm, useEditController, usePermissions, useShowController } from "react-admin";
import { checkPermission } from "../../helpers/checkPermissions";
import { transformDateForInputValue } from "../../helpers/dateHelper";
import { StaffUser } from "../../types/staffUser";
import DocumentTitle from "../common/documentTitle/DocumentTitle";
import CreateNewStaffUserFormBody from "./ScreateNewStaffUserFormBody";


const StaffUserView = (props)=>{
  const { permissions } = usePermissions()
    const controllerProps = useShowController<StaffUser>(props)
    const [isUserBlocked, setDoesUserBlocked] = React.useState<any>(
        controllerProps.record?.isBlocked
      );
      const [rights, setRights] = React.useState<any>();
      const handleUserStatus = () => {
        setDoesUserBlocked(!isUserBlocked);
      };
      const handleChangeUserRights = (rights) => {
        setRights(rights);
      };
      useEffect(() => {
        if (controllerProps.record) {
          setRights(controllerProps.record?.permissions);
          setDoesUserBlocked(controllerProps.record?.isBlocked);
        }
      }, [controllerProps.record]);
    return (
        <>
          <DocumentTitle
            core="Staff"
            purpose={`${controllerProps.record?.name}`}
            appointment={`${controllerProps.record?.surname}`}
          />
          <Show {...props} hasEdit={checkPermission(permissions, "Staff management", "Update")?true:false}>
            {rights && controllerProps.record && (
              <SimpleForm
                toolbar={
                    <CustomToolbar/>
                }
                className="general-tab"
              >
                <CreateNewStaffUserFormBody
                  staffUserRights={rights}
                  creationDate={transformDateForInputValue(
                    controllerProps.record?.startDate
                  )}
                  setRights={handleChangeUserRights}
                  disableInputs={true}
                  userRole={controllerProps.record?.role}
                  isUserBlocked={isUserBlocked}
                  handleChangeUserStatus={handleUserStatus}
                />
              </SimpleForm>
            )}
          </Show>
        </>
      );
}
const CustomToolbar = () => {
    return (
        <>

        </>
    )
}
export default StaffUserView;